import { MultiResponseType } from '../../models/multiResponseType';
import { 
    IReportVisit as ReportVisit
} from '../../models/reportVisit';

export enum ActionType {
    FETCH_REPORTVISITS = 'FETCH_REPORTVISITS',
    FETCH_REPORTVISITS_SUCCESS = 'FETCH_REPORTVISITS_SUCCESS',
    FETCH_REPORTVISITS_FAIL = 'FETCH_REPORTVISITS_FAIL',
    EDIT_REPORTVISIT = 'EDIT_REPORTVISIT',
    EDIT_REPORTVISIT_SUCCESS = 'EDIT_REPORTVISIT_SUCCESS',
    EDIT_REPORTVISIT_FAIL = 'EDIT_REPORTVISIT_FAIL',
}

export interface IFetchReportVisits {
    type: ActionType.FETCH_REPORTVISITS;
}
export interface IFetchReportVisitsSuccess {
    type: ActionType.FETCH_REPORTVISITS_SUCCESS;
    payload: MultiResponseType<ReportVisit>
}
export interface IFetchReportVisitsFail {
    type: ActionType.FETCH_REPORTVISITS_FAIL;
    payload: string | null;
}
export interface IEditReportVisit {
    type: ActionType.EDIT_REPORTVISIT;
}
export interface IEditReportVisitSuccess {
    type: ActionType.EDIT_REPORTVISIT_SUCCESS;
}
export interface IEditReportVisitFail {
    type: ActionType.EDIT_REPORTVISIT_FAIL;
    payload: string | null;
}

export type Action =
    | IFetchReportVisits
    | IFetchReportVisitsSuccess
    | IFetchReportVisitsFail
    | IEditReportVisit
    | IEditReportVisitSuccess
    | IEditReportVisitFail
